import React from 'react'
import { NavLink } from 'react-router-dom';
import AppLogo from '../../../assets/images/logo_psm_white.svg';

const Footer = () => {
    const dt = new Date();
    const Year =  dt.getFullYear();
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-first-level-container">
                    <div className="row footer-first-level-row">
                        <div className="col-lg-4 footer-fl-col">
                            <div className="footer-fl-item-container">
                                <h5 className="footer-fl-item-section-title">Urgence Plombier & Serrurier Montpellier</h5>
                                <div className="footer-section-container footer-brand-section">
                                    <NavLink to="/" className="footer_logo_link">
                                        <img src={AppLogo} alt="Serrurier Montpellier pas cher" className="app-footer-brand-img" />
                                    </NavLink>
                                    <p className="footer-brand-text">
                                        <strong>Urgence Plombier et Serrurier Montpellier pas cher</strong> regroupe des professionnels qui peuvent intervenir trés vite chez vous pour différents services 24H/24, 7J/7.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 footer-fl-col">
                            <div className="footer-fl-item-container">
                                <h5 className="footer-fl-item-section-title">Nos Services</h5>
                                <div className="footer-section-container footer-brand-section">
                                    <ul className="footerapp-services-ul">
                                        <li>
                                            <NavLink to="/plombier-montpellier-pas-cher" className="footer-service-item-link">Urgence Plombier</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/serrurier-montpellier-pas-cher" className="footer-service-item-link">Urgence Serrurier</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/a-propos-de-nous" className="footer-service-item-link">A Propos de nous</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/plombier-montpellier-pas-cher#app-page-service-plomberie-generale" className="footer-service-item-link">Plomberie Générale</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/serrurier-montpellier-pas-cher#app-page-service-ouverture-portes-fermees" className="footer-service-item-link">Ouverture de portes fermées</NavLink>
                                        </li> 
                                        <li>
                                            <NavLink to="/plombier-montpellier-pas-cher#app-page-service-reparation-defuites" className="footer-service-item-link">Réparation de fuites</NavLink>
                                        </li> 
                                        <li>
                                            <NavLink to="/plombier-montpellier-pas-cher#app-page-service-installation-de-portes-blindees" className="footer-service-item-link">Changement de serrure 3 points</NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 footer-fl-col">
                            <div className="footer-fl-item-container">
                                <h5 className="footer-fl-item-section-title">Nous contacter</h5>
                                <div className="footer-section-container footer-brand-section">
                                    <div className="footer-contact-item-container">
                                        <p className="footer-contact-item-title">Adresse</p>
                                        <p className="footer-contact-item-label">129 All. de Bon Accueil, 34090 Montpellier, France</p>
                                    </div>
                                    <div className="footer-contact-item-container">
                                        <p className="footer-contact-item-title">Téléphone</p>
                                        <p className="footer-contact-item-label"> <a href="tel:0646217592" className="footer-contact-cta">06 46 21 75 92</a> </p>
                                    </div>
                                    <div className="footer-contact-item-container">
                                        <p className="footer-contact-item-title">Email</p>
                                        <p className="footer-contact-item-label"> <a href="mailto:contact@intervention-plombier-serrurier24h.fr" className="footer-contact-cta">contact@intervention-plombier-serrurier24h.fr"</a> </p>
                                    </div>
                                    <div className="footer-social-container">
                                        <div className="footer-contact-item-container">
                                            <p className="footer-contact-item-title">Facebook</p>
                                            <p className="footer-contact-item-label"> 
                                                <a href="https://www.facebook.com/plombierSerrurierChauffagisteMontpellier" className="footer-contact-cta">
                                                    <img loading="lazy" src="https://img.icons8.com/ios/50/3b5998/facebook-new.png" alt="Facebook" className="footer-social-icon" />
                                                </a> 
                                            </p>
                                        </div>
                                        <div className="footer-contact-item-container">
                                            <p className="footer-contact-item-title">Youtube</p>
                                            <p className="footer-contact-item-label"> 
                                                <a href="https://www.youtube.com/channel/UCGTrjblccj3VWnk_53cgHGA" className="footer-contact-cta">
                                                    <img loading="lazy" src="https://img.icons8.com/ios/50/c4302b/youtube-play--v1.png" alt="Youtube" className="footer-social-icon" />
                                                </a> 
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-divider"></div>
                <div className="second-level-container">
                    <div className="row footer-second-level-row">
                        <div className="col-lg-12 footer-sl-col">
                            <div className="footer-sl-body">
                                &copy; { Year } <span>Serrurier pas cher Montpellier</span> - &nbsp;
                                <span>Site web designé et conçu par <a href="mailto:sadio.sanghare@nahawa.click" className="author-link">Sadio Sangharé</a> </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer